// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n0TJ","footer":"styles_footer__2KFY4","passCodeTooltip":"styles_passCodeTooltip__2FZvH"};